import React, { useContext, useEffect, useState } from "react"
import { BookingContext } from "../../../utils/providers/booking"
import { AuthContext } from "../../../utils/providers/auth"
import { db } from "../../../utils/firebase"

// UI components
import Table from "../../../components/structure/table/table"
import Log from "../../../components/booking/logs/log"
import Loading from "../../../components/app/loading/loading"

// Functional component to return the booking logs panel
export default function Logs() {
	const [logs, setLogs] = useState([])
	const [loading, setLoading] = useState(true)
	const { bookingID } = useContext(BookingContext)
	const { user } = useContext(AuthContext)

	// On component load
	useEffect(() => {
		// Fetch the logs for this booking once
		const fetchLogs = async () => {
			const logDocs = await db.collection(`bookings/${bookingID}/logs`).orderBy("created", "desc").get()

			// Map the logs and filter out diff logs
			const fetchedLogs = logDocs.docs
				.map((doc) => ({
					id: doc.id,
					...doc.data(),
				}))
				.filter((log) => !log.diff)

			setLogs(fetchedLogs)
			setLoading(false)
		}

		fetchLogs()
	}, [bookingID])

	if (loading) {
		return (
			<div className="booking__logs-container">
				<Loading />
			</div>
		)
	}

	return (
		<div className="booking__logs-container">
			<Table
				className="logs-table"
				headings={["Event", "When", "User", "Message"]}>
				{logs.map((log) => (
					<Log
						key={log.id}
						details={log}
						maskDetails={user?.mask_details}
					/>
				))}
			</Table>
		</div>
	)
}
